import { useEffect, useState } from 'react';

import { useTurnOffCustomizationListLang } from './useTurnOffCustomizationListLang';

import type {
  FullMenuCatalog,
  IMenuCustomization,
} from 'features/menu-page/domain';
import type { ChangeEvent } from 'react';
import type { CustomizationId } from 'shared/domain';

export function useTurnOffCustomizationList(props: Props) {
  const { catalog, customizationList, turnOffCTA } = props;

  const [customs, setCustoms] = useState<_CustomExtra[]>([]);
  const [checked, setChecked] = useState<Set<CustomizationId>>(new Set());

  const lang = useTurnOffCustomizationListLang();

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const _isChecked = event.target.checked;
    const _customId = Number(event.target.name);
    if (isNaN(_customId)) {
      setChecked(_isChecked ? new Set(customs.map(c => c.id)) : new Set());
      return;
    }
    const _checks = new Set(checked);
    if (_isChecked) _checks.add(_customId);
    else _checks.delete(_customId);
    setChecked(_checks);
  };

  const handleCallToAction = () => {
    turnOffCTA(Array.from(checked));
  };

  useEffect(() => {
    setCustoms([
      ...new Map(
        customizationList.map(custom => [
          custom.id,
          {
            ...custom,
            extra: catalog.customizationGroups
              .filter(cg => cg.items.some(i => i.id === custom.id))
              .reduce(
                (acc, cg) => ({
                  title: cg.description,
                  description: [
                    acc.description,
                    catalog.products.find(p => p.id === cg.productId)?.name,
                  ]
                    .join(', ')
                    .replace(/^, /, ''),
                }),
                { title: '', description: '' },
              ),
          },
        ]),
      ).values(),
    ]);
  }, [customizationList]);

  return {
    lang,
    customs,
    checked,
    isCheckAll: checked.size === customs.length,
    disableCTA: checked.size === 0,
    handleOnChange,
    handleCallToAction,
  };
}

interface Props {
  catalog: FullMenuCatalog;
  customizationList: IMenuCustomization[];
  turnOffCTA: (ids: CustomizationId[]) => void;
}

interface _CustomExtra extends IMenuCustomization {
  extra: {
    title: string;
    description: string;
  };
}
